import * as React from "react";
import Spinner from '../../../common/components/spinner/spinner';
import Translate from '../../../common/functions/translate';
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../../../common/modalDialog';
import UserService from '../../../services/userService';
import AuthService from '../../../services/authService';
import Growl from '../../../common/components/alertMessage/growl';
import { UserForGridModel } from "../../../models/user";
import UserFamilyList from './userFamilyList';
import UserFamilyAddEditDialog from './userFamilyAddEditComponent';
import UserPersonalDataTab from '../userProfile/userPersonalDataTab';
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import * as HelperFunctions from "../../../common/functions/helperFunctions";
import ExpandingList from '../../../common/components/expandingList/expandingList';
import CSSTransition from 'react-transition-group/CSSTransition';
import { RelationType, UserType, RequestStatus } from '../../../common/enums';
import { getEnumLabel } from '../../../common/functions/helperFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faPills, faNotesMedical, faChevronUp, faChevronDown, faUtensils, faStethoscope, faAllergies } from '@fortawesome/free-solid-svg-icons';
import * as Constants from '../../../common/constants';

interface IProps {
  history: any;
  location: any;
}

interface IState {
  isLoading: boolean;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  users: Array<UserForGridModel>;
  isVisibleDialog: boolean;
  currentUser: UserForGridModel;
  isVisibleMyFriendEdit: boolean;
  selectedUserId: number;
  isVisibleConfirmDialog: boolean;
  deleteValidationMessage: string;
  isVisibleConfirmCaretakerDialog: boolean;
  deleteValidationCaretakerMessage: string;
  selectedUserName: string;
  dialogHeader: string;
  isVisiblePersonalData: boolean;
  expandedUsers: Array<UserForGridModel>;
}

enum MyFriendEditTabs {
  PersonalData = 0,
  Medicines = 1,
  Diseases = 2
}

class UserFamilyComponent extends React.Component<IProps, IState> {
  growl: any;
  initFrom = 0;
  numberOfRows = 10;

  userService = new UserService();
  authService = new AuthService();

  constructor(props: IProps) {
    super(props);
    this.state = {
      isLoading: false,
      from: this.initFrom,
      numberOfRows: this.numberOfRows,
      totalRecordsCount: 0,
      users: new Array<UserForGridModel>(0),
      isVisibleDialog: false,
      currentUser: new UserForGridModel(),
      isVisibleMyFriendEdit: false,
      selectedUserId: 0,
      isVisibleConfirmDialog: false,
      deleteValidationMessage: '',
      selectedUserName: '',
      dialogHeader: '',
      isVisiblePersonalData: false,
      isVisibleConfirmCaretakerDialog: false,
      deleteValidationCaretakerMessage: '',
      expandedUsers: new Array<UserForGridModel>(0)
    };
  }

  componentDidMount() {
    this.getAllFriends();
  }

  componentDidUpdate(prevProps) {
    const locationChanged = this.props.location !== prevProps.location;
    if (locationChanged) {
      let tabName = HelperFunctions.getURLParameter('tabName');

      if (tabName && tabName == 'Account' && this.props.history.action === "POP") {
        let userId = HelperFunctions.getURLParameter('userId');
        let userName = HelperFunctions.getURLParameter('userName');
        let numUser: number = userId ? parseInt(userId + '') : 0;
        this.handleaccount(numUser, userName + '');
      }
      if (!tabName && this.props.history.action === "POP") {
        this.setState({ isVisibleMyFriendEdit: false }, () => this.getAllFriends());
      }
    }
  }


  getAllFriends() {
    this.setState({
      isLoading: true
    });

    if (this.authService.isAuthenticated()) {

      this.userService.getMyFamily().then(
        (data: any) => {
          if (data) {
            this.setState({
              isLoading: false,
              users: data
            });
          }
        })
        .catch(error => {
          this.growl.show({ severity: 'error', summary: error.message });
          this.setState({
            isLoading: false
          });
        });
    }
  }

  handleOnPageClick = (e) => {
    const startIndex = e.first;
    //this.getAllUsers(startIndex, this.state.numberOfRows);
  }

  handleAddAndEditClick = id => {
    if (!id) { // Add			
      this.setCurrentUser(new UserForGridModel());
      this.setState({ dialogHeader: Translate('AddindFamily') });
      this.showEditDialog(true);
    } else { // Edit
      this.setState({
        isLoading: true,
        dialogHeader: Translate('EditingFamily')
      });
      this.userService.getUserFromMyFamily(id)
        .then(
          (data: UserForGridModel) => {
            this.setCurrentUser(data);
            this.showEditDialog(true);
            this.setState({
              isLoading: false
            });
          },
          error => {
            this.growl.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false
            });
          }
        );
    }
  };

  handleMedicines = (id: number, name: string) => {
    if (!id) {
      console.log("ERR");
    } else {
      this.props.history.push(`medicines?tabName=Family&userId=${id}&userName=${name}`);
    }
  }

  handleDiseases = (id: number, name: string) => {
    if (!id) {
      console.log("ERR");
    } else {
      this.props.history.push(`diseases?tabName=Family&userId=${id}&userName=${name}`);
    }
  }

  handleaccount = (id: number, name: string) => {
    if (!id) {
      console.log("ERR");
    } else {
      this.setState({
        selectedUserId: id,
        isVisiblePersonalData: true,
        selectedUserName: name
      });

    }
  }

  handleAddEditSaveClick = (user: UserForGridModel, close: boolean) => {
    this.setState({
      isLoading: true
    });
    if (!user.userId || user.userId <= 0) {
      this.userService.addMemberInMyFamily(user)
        .then(
          (data) => {
            if (close) {
              this.handleCloseAddEditClick();
            }
            this.growl.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
            this.setCurrentUser(new UserForGridModel);
            this.getAllFriends();
          },
          error => {
            this.handleCloseAddEditClick();
            this.setCurrentUser(new UserForGridModel);
            this.growl.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false
            });
          }
        );
    }
    else {
      this.userService.updateMyMemberFromFamily(user)
        .then(
          (data) => {
            if (close) {
              this.handleCloseAddEditClick();
            }
            this.growl.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
            this.setCurrentUser(new UserForGridModel);
            this.getAllFriends();
          },
          error => {
            this.handleCloseAddEditClick();
            this.setCurrentUser(new UserForGridModel);
            this.growl.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false
            });
          }
        );
    }

  }

  handleAddCaretakerSaveClick = (user: UserForGridModel, close: boolean) => {
    if (this.state.users.some(r => r.userId == user.userId)) {
      this.growl.show({ severity: 'error', summary: Translate("AlreadyExist") });
      return;
    }
    this.setState({
      isLoading: true
    });

    this.userService.addCaretaker(user)
      .then(
        (data) => {
          if (close) {
            this.handleCloseAddEditClick();
          }
          this.growl.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
          this.setCurrentUser(new UserForGridModel);
          this.getAllFriends();
        },
        error => {
          this.handleCloseAddEditClick();
          this.setCurrentUser(new UserForGridModel);
          this.growl.show({ severity: 'error', summary: error.message });
          this.setState({
            isLoading: false
          });
        }
      );
  }


  handleDeleteRelationClick = (userId) => {
    this.setState({
      isVisibleConfirmCaretakerDialog: true
    });

    let deleteValidationMessage = '';
    this.userService.getUserFromMyFamily(userId)
      .then(
        (data: UserForGridModel) => {
          this.setCurrentUser(data);

          let currentUser = this.state.currentUser;
          if (currentUser) {
            let userName = currentUser.name;
            deleteValidationMessage = Translate("Confirm Message") + " " + userName + "?";
          }

          this.setState({
            isLoading: false,
            deleteValidationCaretakerMessage: deleteValidationMessage,
            isVisibleConfirmCaretakerDialog: true
          });

        },
        error => {
          this.growl.show({ severity: 'error', summary: Translate(error.message) });
          this.setState({
            isLoading: false
          });
        });
  }

  handleDeleteClick = (userId: number) => {
    this.setState({
      isVisibleConfirmDialog: true
    });

    let deleteValidationMessage = '';
    this.userService.getUserFromMyFamily(userId)
      .then(
        (data: UserForGridModel) => {
          this.setCurrentUser(data);

          let currentUser = this.state.currentUser;
          if (currentUser) {
            let userName = currentUser.name;
            deleteValidationMessage = Translate("Confirm Message") + " " + userName + "?";
          }

          this.setState({
            isLoading: false,
            deleteValidationMessage: deleteValidationMessage,
            isVisibleConfirmDialog: true
          });

        },
        error => {
          this.growl.show({ severity: 'error', summary: Translate(error.message) });
          this.setState({
            isLoading: false
          });
        });
  }

  deleteUserFriend = (id: number) => {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    this.userService.deleteUserFromFamily(id)
      .then(
        data => {
          this.growl.show({ severity: 'success', summary: Translate('Deleted Successfully') });
          this.getAllFriends();
        },
        error => {
          this.growl.show({ severity: 'error', summary: Translate(error.message) });
          this.setState({
            isLoading: false
          });
        });
  }

  deleteUserCaretaker = (id: number) => {
    this.setState({
      isVisibleConfirmCaretakerDialog: false,
      isLoading: true
    });

    this.userService.deleteCaretaker(id)
      .then(
        data => {
          this.growl.show({ severity: 'success', summary: Translate('Deleted Successfully') });
          this.getAllFriends();
        },
        error => {
          this.growl.show({ severity: 'error', summary: Translate(error.message) });
          this.setState({
            isLoading: false
          });
        });
  }

  handleCloseAddEditClick = () => {
    this.setState({
      isVisibleDialog: false
    });
  }

  showEditDialog = (show: boolean) => {
    this.setState({
      isVisibleDialog: show
    });
  };

  setCurrentUser(user: UserForGridModel) {
    this.setState({ currentUser: { ...user } });
  }

  toMyFriends = (event) => {
    event.preventDefault();
    this.setState({ isVisibleMyFriendEdit: false });
    this.getAllFriends();
    this.props.history.push(`/user/family`);
  }

  getTabIndex(tabName) {
    switch (tabName) {
      case 'PersonalData':
        return MyFriendEditTabs.PersonalData;
      case 'Medicines':
        return MyFriendEditTabs.Medicines;
      case 'Diseases':
        return MyFriendEditTabs.Diseases;
    }
    return MyFriendEditTabs.PersonalData;
  }

  handleCancelButton = () => {
    this.setState({ isVisiblePersonalData: false });
  }

  handleOnSave = () => {
    this.handleCancelButton();
    this.getAllFriends();
    this.growl.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
  }

  expandedData = (rowData: UserForGridModel) => {
    if (rowData.userTypeId == UserType.UserCreated) {
      return (
        <div className="item-actions-panel">
          <button
            type="button"
            className="item-actions-panel-buttons btn-info"
            onClick={() => this.handleaccount(rowData.userId, rowData.name)}
            style={{ width: 50 }}
          ><FontAwesomeIcon style={{ verticalAlign: 'text-top' }} icon={faUser}></FontAwesomeIcon></button>
          <button
            type="button"
            className="item-actions-panel-buttons btn-info"
            style={{ width: 50 }}
            onClick={() => this.handleMedicines(rowData.userId, rowData.name)}
          >
            <FontAwesomeIcon style={{ verticalAlign: 'text-top' }} icon={faPills}></FontAwesomeIcon>
          </button>
          <button
            type="button"
            className="item-actions-panel-buttons btn-info"
            style={{ width: 50 }}
            onClick={() => this.handleDiseases(rowData.userId, rowData.name)}>
            <FontAwesomeIcon style={{ verticalAlign: 'text-top' }} icon={faStethoscope} />
          </button>
          <button
            type="button"
            className="item-actions-panel-buttons btn-warning"
            style={{ width: 50 }}
            onClick={() => this.handleAddAndEditClick(rowData.userId)}
          > <i style={{ verticalAlign: 'text-top' }} className="pi pi-pencil"></i></button>
          <button
            type="button"
            className="item-actions-panel-buttons btn-danger"
            style={{ width: 50 }}
            onClick={() => this.handleDeleteClick(rowData.userId)}
          ><i style={{ verticalAlign: 'text-top' }} className="pi pi-trash"></i></button>
        </div >
      );
    }
    else {
      return (
        <div className="item-actions-panel">
          <button
            type="button"
            className="p-button-danger item-actions-panel-buttons"
            style={{
              marginRight: ".5em", fontSize: 16, backgroundColor: '#e91224', color: 'white', border: 'none',
              borderRadius: '3px',
              width: 50
            }}
            onClick={() => this.handleDeleteRelationClick(rowData.userId)}
          ><i style={{ verticalAlign: 'text-top' }} className="pi pi-trash"></i></button>
        </div >
      );
    }
  }

  rowExpansionTemplate = (rowData: UserForGridModel) => {
    return (
      <CSSTransition in={this.state.expandedUsers.some(r => r.userId == rowData.userId)}
        timeout={300} classNames="list-slide" mountOnEnter unmountOnExit>
        {this.expandedData(rowData)}
      </CSSTransition>
    );
  }

  expandData = (data: UserForGridModel) => {
    if (!this.state.expandedUsers.some(r => r.userId == data.userId) || this.state.expandedUsers.length == 0) {
      this.setState({ expandedUsers: [...this.state.expandedUsers, data] });
    } else {
      this.setState({ expandedUsers: this.state.expandedUsers.filter(r => r.userId != data.userId) });
    }
  }

  keyItem = (user: UserForGridModel) => {
    return user.userId + "user";
  }

  itemName = (user: UserForGridModel) => {
    return user.name;
  }

  itemDesc = (user: UserForGridModel) => {
    return (
      <>
        {getEnumLabel(user.relationType, RelationType, true)}
        {user.userTypeId == UserType.UserCreated ?
          <>
            {user.notAllowedFoods ?
              <div className="item-desc-info">
                <FontAwesomeIcon style={{ paddingRight: '5px', paddingLeft: '3px', width: '24px', height: '15px' }} icon={faUtensils} />
                {user.notAllowedFoods}
              </div> : null}
            {user.allergies ?
              <div className="item-desc-info">
                <FontAwesomeIcon style={{ paddingRight: '5px', paddingLeft: '3px', width: '24px', height: '15px' }} icon={faAllergies} />
                {user.allergies}
              </div> : null}
            <div className="item-desc-info">
              <FontAwesomeIcon style={{ paddingRight: '5px', paddingLeft: '3px', width: '24px', height: '15px' }} icon={faPills} />
              {Translate('Medicines')}
              <div className="badge text-badge">
                {user.medicineCount ? user.medicineCount : '0'}
              </div>
            </div>
            <div className="item-desc-info">
              <FontAwesomeIcon style={{ paddingRight: '5px', width: '24px', height: '15px' }} icon={faStethoscope} />
              {Translate('Diseases')}
              <div className="badge text-badge">
                {user.diseasesCount ? user.diseasesCount : '0'}
              </div>
            </div>
          </>
          : <div>{getEnumLabel(user.requestStatusId, RequestStatus, true)}</div>}
      </>
    )
  }

  itemActions = (user: UserForGridModel) => {
    return (
      <>
        {window.innerWidth >= Constants.device.tablet ? this.expandedData(user) :

          this.state.expandedUsers.some(r => r.userId == user.userId) ?
            <FontAwesomeIcon icon={faChevronUp} />
            : <FontAwesomeIcon icon={faChevronDown} />
        }
      </>
    )
  }

  public render() {
    const { isLoading, users, totalRecordsCount, isVisibleDialog, currentUser,
      isVisiblePersonalData, selectedUserId, selectedUserName, dialogHeader, isVisibleConfirmCaretakerDialog, deleteValidationCaretakerMessage } = this.state;

    return (
      <div className="app-content">
        <div>
          {isLoading ? <Spinner /> : null}
          <Growl ref={(el) => this.growl = el} />

          <div style={{ width: '100%' }}>
            <h2>{Translate('My Family')}</h2>

            <Fab color="primary" aria-label="Add" size="small" onClick={() => this.handleAddAndEditClick(null)} className="floating-action-button">
              <AddIcon />
            </Fab>

            {!isLoading && users && users.length > 0 ?
              <div className="list-items-count-info">
                <span className='list-items-count-info-number'>{users.length}</span> {Translate('total records.')}
              </div> : null}

            <ExpandingList
              listItems={users}
              keyItem={this.keyItem}
              expandData={this.expandData}
              expandedPanel={this.rowExpansionTemplate}
              itemName={this.itemName}
              itemDesc={this.itemDesc}
              itemActions={this.itemActions}
              isExpandable={window.innerWidth < Constants.device.tablet}
              infoStyle={window.innerWidth < Constants.device.tablet ? {} : { width: 'unset' }}
            />

            {/* <UserFamilyList
              users={users}
              handleAddAndEditClick={this.handleAddAndEditClick}
              handleAccount={this.handleaccount}
              handleMedicines={this.handleMedicines}
              handleDiseases={this.handleDiseases}
              handleDelete={this.handleDeleteClick}
              handleDeleteRelation={this.handleDeleteRelationClick}
            /> */}
            {!isLoading && (!users || users.length == 0) ? Translate("No records found") : null}
          </div>
        </div>

        {isVisiblePersonalData ?
          <Dialog
            open={isVisiblePersonalData}
            onClose={this.handleCancelButton}
            fullWidth
          >
            <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{Translate('InfoForUser') + " " + selectedUserName}</Modal.DialogTitle>
            <Modal.DialogContent>
              <UserPersonalDataTab
                history={this.props.history}
                userId={selectedUserId}
                onCancelClick={this.handleCancelButton}
                onSave={this.handleOnSave}>
              </UserPersonalDataTab>
            </Modal.DialogContent>
          </Dialog>
          : null}

        {isVisibleDialog ? <UserFamilyAddEditDialog isVisible={isVisibleDialog}
          saveClick={this.handleAddEditSaveClick}
          cancelClick={this.handleCloseAddEditClick}
          selectedUser={currentUser}
          dialogHeader={dialogHeader}
          saveCaretakerClick={this.handleAddCaretakerSaveClick}></UserFamilyAddEditDialog>
          : null}

        <ConfirmDialog
          headerTitle={Translate("Confirm Dialog")}
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteUserFriend(currentUser.userId) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false, deleteValidationMessage: '' }) }}>
          {this.state.deleteValidationMessage}
          {/* Are you sure that you want to delete&nbsp;
          {currentUserMedicine.medicine
            ? [currentUserMedicine.medicine.brandName, currentUserMedicine.medicine.brandNameBG, currentUserMedicine.medicine.additionalTitle].filter(Boolean).join(' / ')
            : "this record"}? */}
        </ConfirmDialog>

        <ConfirmDialog
          headerTitle={Translate("Confirm Dialog")}
          isVisible={isVisibleConfirmCaretakerDialog}
          yesClick={() => { this.deleteUserCaretaker(currentUser.userId) }}
          noClick={() => { this.setState({ isVisibleConfirmCaretakerDialog: false, deleteValidationCaretakerMessage: '' }) }}>
          {deleteValidationCaretakerMessage}
          {/* Are you sure that you want to delete&nbsp;
          {currentUserMedicine.medicine
            ? [currentUserMedicine.medicine.brandName, currentUserMedicine.medicine.brandNameBG, currentUserMedicine.medicine.additionalTitle].filter(Boolean).join(' / ')
            : "this record"}? */}
        </ConfirmDialog>


      </div>
    )
  }
}

export default UserFamilyComponent;